import { TraceActions } from './trace.actions';

export const initialTraceState: IStateTrace = { nodes: {}, selectAll: false, changeState : false };

export function traceReducer (state: IStateTrace = initialTraceState, action: any)  {
    switch (action.type) {
        case TraceActions.UPDATE:
            const value = {};
            value[action.payload.parent] = action.payload.nodes;
            const nodes = {...state.nodes, ...value};
            return  {...state, nodes, changeState: action.payload.changeState};

        case TraceActions.SELECTALL:
            return  {...state, selectAll: action.payload, changeState: true};
        default:
            return state;
    }
};
